import OrganizationPage from './OrganizationPage';

export default OrganizationPage;
